<div class="completed-certification-details w-100">
  <div class="color-success">
    <strong>
      <mat-icon class="align-middle">assignment_turned_in<br /></mat-icon
      ><span>{{ 'Certification.Score' | translate }}:&nbsp;</span></strong
    ><span>{{ scores.label(certification.score, certification.language) }}</span>
  </div>
  <div>
    <strong>
      <mat-icon class="align-middle">class<br /></mat-icon
      ><span>{{ 'Certification.CertificateNo' | translate }}:&nbsp;</span></strong
    ><span>{{ certification.certificationNumber }}</span>
  </div>
  <div>
    <strong>
      <mat-icon class="align-middle">class<br /></mat-icon
      ><span>{{ 'Certification.SerialNo' | translate }}:&nbsp;</span></strong
    ><span>{{ certification.serialNumber }}</span>
  </div>
  <div>
    <strong>
      <mat-icon class="align-middle">event_available</mat-icon
      ><span>{{ 'Certification.Completion' | translate }}:&nbsp;</span></strong
    ><span>{{ certification.completedDate | kortoDate }}</span>
  </div>
  <div>
    <strong>
      <mat-icon class="align-middle">event_busy</mat-icon
      ><span>{{ 'Certification.Expiry' | translate }}:&nbsp;</span></strong
    ><span>{{ certification.expiryDate | kortoDate }}</span>
  </div>
  <ng-container *ngIf="showCompletedCertificatonOptions">
    <div>
      <a id="recieve-certificate" class="text-primary w-auto" (click)="openReceiveDialog()">
        <img src="../../../assets/images/Certificate.svg" style="width:24px;height:24px;margin-right:3px;">
        <strong><span translate="Dashboard.CompletedCertification.Receive"></span></strong>
      </a>
    </div>
    <div>
      <a
        class="text-primary w-auto"
        [routerLink]="['/profile']"
        [queryParams]="{ certificationId: certification.id }"
        routerLinkActive="router-link-active"
      ><mat-icon>more_horiz</mat-icon><span translate="Dashboard.CompletedCertification.MoreOptions"></span>
      </a>
    </div>
  </ng-container>
</div>
